//
//
//
//
//
//
//
//
//
//

import banner from '@/assets/nvzhigongquanyi2/banner.png'
import { getview } from '@/api/jfhl.js'
export default {
  name: 'nvzhigongquanyiRule2',
  components: {},
  data() {
    return {
      partyid: this.$route.params.partyid,
      banner: banner,
      explist: []
    }
  },
  watch: {},
  mounted() {
    this.view()
  },
  methods: {
    // 获取问卷id
    view() {
      getview({
        id: this.partyid
      }).then(res => {
        this.explist = res.obj.explist
      })
    }
  },
  created() {}
}
